import { render, staticRenderFns } from "./CriminalRecordAdd.vue?vue&type=template&id=530f435e&"
import script from "./CriminalRecordAdd.vue?vue&type=script&lang=js&"
export * from "./CriminalRecordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports